<mat-slide-toggle
  [labelPosition]="labelPosition()"
  [disabled]="disabled()"
  [class]="color()"
  [color]="'primary'"
  [ngModel]="viewValue()"
  (ngModelChange)="updateValue($event)"
  (blur)="markAsTouched()">
  {{ label() }}
  @if (required()) {
    *
  }
</mat-slide-toggle>
